/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
import styled from 'styled-components';
import {Collapsible, FontSizes, FontWeights, Text, minWidth} from '@calm-web/design-system';
import {FaqItem} from '@/components/homepageRefresh/homepage/FAQ/styles';
function _createMdxContent(props) {
  const _components = Object.assign({
    h3: "h3",
    p: "p",
    strong: "strong",
    ul: "ul",
    li: "li",
    a: "a",
    ol: "ol"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h3, {
      children: "SLEEP"
    }), "\n", _jsxs(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'What makes Calm’s Sleep Stories® unique?',
      children: [_jsx("br", {}), _jsx(_components.p, {
        children: "As the original creators of Sleep Stories®, we pride ourselves in high-quality, masterfully mixed content. All Sleep Stories® are originally written stories developed by Calm’s team of top producers."
      }), _jsx(_components.p, {
        children: "Many of our narrators are also names you may already be familiar with, from artists like Harry Styles and Michael Bublé to actors and actresses such as Jennifer Garner and Matthew McConaughey."
      }), _jsx(_components.p, {
        children: "Lastly, with over 300 Sleep Stories® in our library, we have a library fit for both adults and kids, making our app something the whole family can enjoy. Kids can enjoy exclusive Sleep Stories® featuring favorite characters such as Peppa Pig, Minions, Winnie the Pooh, Transformers, and more."
      })]
    }), "\n", _jsxs(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'How are customers getting better sleep with Calm?',
      children: [_jsx("br", {}), _jsx(_components.p, {
        children: "Calm's library has over 1,000 offerings made specifically for sleep from Sleep Stories® to soundscapes and guided sleep meditations."
      }), _jsx(_components.p, {
        children: "With our app, you can establish a bedtime routine that helps you relax, fall asleep quickly, and keep you in a deep slumber through the night."
      }), _jsx(_components.p, {
        children: "Explore and preview Calm's different sleep tools, including an exclusive Sleep Story, below or sign up for your free trial to unlock the full library."
      })]
    }), "\n", _jsxs(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'What can I expect from Sleep Stories®?',
      children: [_jsx("br", {}), _jsxs(_components.p, {
        children: ["Our Sleep Stories® ", _jsx(_components.strong, {
          children: "mix music, sound effects and voice talent to help you fall into a restful sleep."
        }), " Most of the time, our users don’t actually make it to the end of the story before falling asleep!"]
      }), _jsxs(_components.p, {
        children: ["You can find a variety of stories about everything from the Sierra Nevada to magical waterfalls. ", _jsx(_components.strong, {
          children: "Our stories help you transition from the hustle and bustle of daily life to the calm of the evening."
        }), " We even have a nap category if you're looking for a quick rest."]
      }), _jsx(_components.p, {
        children: "We offer a variety of categories including Fiction, Nature, and Music with stories read by over 50 different narrators. We even have some stories that were created to induce ASMR (Autonomous sensory meridian response), a reaction that some people experience when exposed to certain auditory stimuli."
      })]
    }), "\n", _jsxs(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'I am having trouble falling asleep—where do I get started with Calm?',
      children: [_jsx("br", {}), _jsx(_components.p, {
        children: "After signing up for your free trial, we recommend downloading our app for convenient access to Calm's full library of content and tools."
      }), _jsx(_components.p, {
        children: "In the app, we recommend starting with our Fall Asleep collection, which features our most popular Sleep Stories®, soundscapes, music, and meditations based on your goals:"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Help falling asleep: natural sleep aids"
        }), "\n", _jsx(_components.li, {
          children: "Getting back to sleep: reactive tools used to soothe and lull you back to sleep"
        }), "\n", _jsx(_components.li, {
          children: "Unwinding before bed: proactive tools to help start a sleep routine and focuses on sleep hygiene - this means focusing on building habits and an environment designed for optimal sleep"
        }), "\n", _jsx(_components.li, {
          children: "We also have a Sleep Check-In feature which offers a new way to track your sleep. Check in with your nightly sleep quality, and we'll show you patterns to guide you towards better sleep habits and health."
        }), "\n"]
      })]
    }), "\n", _jsx(_components.h3, {
      children: "GENERAL"
    }), "\n", _jsxs(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'What is Calm?',
      children: [_jsx("br", {}), _jsxs(_components.p, {
        children: ["Calm is the #1 mental health app designed to help you manage stress, sleep better, and live a happier,\nhealthier life. Our research-based tools help you build life-changing habits to support your mental health.\nIf you're having trouble falling asleep, our 250+ ", _jsx(_components.a, {
          href: "/app/class/sleep-popular-sleep-stories",
          children: "Sleep Stories"
        }), "®, soundscapes, and guided ", _jsx(_components.a, {
          href: "/app/sleep/meditations",
          children: "sleep meditations"
        }), "\ncan lull you to sleep. If you're spiraling in negative thoughts and need immediate relief, our 60-second\nBreathe Bubble grounds you in the moment and helps your body return to a state of relaxation. If you're\noverwhelmed at work and need a breather, our ", _jsx(_components.a, {
          href: "/app/class/work-managing-overwhelm",
          children: "stress and burnout specialists"
        }), " can guide you through exercises\nto help calm your mind. We're here for you whenever or wherever you need us with more content and tools\nbeing added monthly."]
      })]
    }), "\n", _jsxs(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: "What's included in a Calm subscription?",
      children: [_jsx("br", {}), _jsxs(_components.p, {
        children: ["A Calm subscription unlocks our full library of ", _jsx(_components.a, {
          href: "/app/class/meditate-quick-and-easy",
          children: "meditations"
        }), ", ", _jsx(_components.a, {
          href: "/app/class/sleep-popular-sleep-stories",
          children: "Sleep Stories"
        }), ", ", _jsx(_components.a, {
          href: "/app/music",
          children: "music"
        }), ", and other features. The\nsubscription includes:"]
      }), _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["Multiple original ", _jsx(_components.a, {
            href: "/app/dailies",
            children: "daily offerings"
          }), " from a range of teachers to give your day a dose of wisdom, gratitude and encouragement"]
        }), "\n", _jsxs(_components.li, {
          children: ["Hours of ", _jsx(_components.a, {
            href: "/app/class/meditate-quick-and-easy",
            children: "guided meditations"
          }), " covering sleep, anxiety, stress, gratitude, and much more"]
        }), "\n", _jsxs(_components.li, {
          children: ["Our entire library of more than 250+ ", _jsx(_components.a, {
            href: "/app/class/sleep-popular-sleep-stories",
            children: "Sleep Stories"
          }), ", with new stories added every week"]
        }), "\n", _jsxs(_components.li, {
          children: ["Exclusive ", _jsx(_components.a, {
            href: "/app/music",
            children: "music"
          }), " tracks for focus, relaxation, and sleep"]
        }), "\n"]
      })]
    }), "\n", _jsxs(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'Where should I get started once I download the app?',
      children: [_jsx("br", {}), _jsxs(_components.p, {
        children: ["If you have come to Calm to learn relaxation techniques and improve aspects of your mental health, we\nrecommend beginning with the ", _jsx(_components.a, {
          href: "/app/program/qK3IeqhiJP",
          children: "7 Days of Calm"
        }), ", our introductory program that offers the basics of meditation,\nand then move on to the ", _jsx(_components.a, {
          href: "/app/program/YAcrQol9Wv",
          children: "21 Days of Calm"
        }), ". With that foundation, you can explore our library of sessions and\nprograms, which address themes such as ", _jsx(_components.a, {
          href: "/app/meditate/anxiety",
          children: "anxiety"
        }), ", ", _jsx(_components.a, {
          href: "/app/sleep",
          children: "sleep"
        }), ", ", _jsx(_components.a, {
          href: "/app/meditate/focus",
          children: "focus"
        }), ", and ", _jsx(_components.a, {
          href: "/app/meditate/self-care",
          children: "gratitude"
        }), ". Additionally, for moments of\nacute stress or anxiety, we offer in-the-moment calming exercises via our ", _jsx(_components.a, {
          href: "/app/program/_kCx96PwDb",
          children: "Panic SOS"
        }), ", ", _jsx(_components.a, {
          href: "/app/program/whzIxMJxVR",
          children: "Body Scan"
        }), ", and\nbreathing exercise features."]
      }), _jsxs(_components.p, {
        children: ["If you have come to Calm to improve your sleep, we have a collection of over 250 ", _jsx(_components.a, {
          href: "/app/class/sleep-popular-sleep-stories",
          children: "Sleep Stories"
        }), " to help you drift off to restful sleep, ranging from ", _jsx(_components.a, {
          href: "/app/player/h5JpJ0Fqb2",
          children: "classic literature"
        }), " to ", _jsx(_components.a, {
          href: "/app/class/tagged-sleep-nature",
          children: "nature essays"
        }), ",\n", _jsx(_components.a, {
          href: "/app/class/tagged-sleep-kids",
          children: "children's tales"
        }), ", scientific articles, and more. We update our Sleep Stories selection with new options to\nlisten to every week. We also have a collection of soothing Sleep Music."]
      })]
    }), "\n", _jsxs(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'What devices support the Calm app?',
      children: [_jsx("br", {}), _jsx(_components.p, {
        children: "Calm is available on iOS, Android, Web, in addition to Apple TV, Apple Watch,\nGoogle WearOS, and Samsung Health."
      })]
    }), "\n", _jsxs(FaqItem, {
      triggerTextColor: "bannerText",
      trigger: 'How do I cancel?',
      children: [_jsx("br", {}), _jsx(_components.p, {
        children: "You can cancel your Calm subscription's auto-renewal or free trial at any time."
      }), _jsx(_components.p, {
        children: "To cancel your Calm subscription:"
      }), _jsxs(_components.ol, {
        children: ["\n", _jsx(_components.li, {
          children: "Tap 'Profile' on your app's Home screen."
        }), "\n", _jsx(_components.li, {
          children: "Tap the 'Settings' gear icon in the top left corner of your screen."
        }), "\n", _jsx(_components.li, {
          children: "Tap 'Manage Subscription' and follow the instructions here to cancel your subscription."
        }), "\n", _jsx(_components.li, {
          children: "For subscriptions purchased through Apple and Google Play, tap the word 'here' on your Manage Subscription page to be redirected to your device's subscription settings."
        }), "\n"]
      })]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
